export default __webpack_public_path__ + "static/media/clip-1723.27f34d8f.png";